import { createFileRoute } from "@tanstack/react-router";
import { HeroBanner } from "@/components/HeroBanner";
import { CONTACT } from "@/config/contact";
import { buildSeoMeta } from "@/lib/seo";
import { buildBreadcrumbJsonLd } from "@/lib/breadcrumb-jsonld";

const BREADCRUMB = buildBreadcrumbJsonLd([
  { name: "Forside", path: "" },
  { name: "Handelsbetingelser", path: "handelsbetingelser" },
]);

export const Route = createFileRoute("/handelsbetingelser")({
  head: () => buildSeoMeta({
    title: "Handelsbetingelser · AutoXChange",
    description:
      "Læs AutoXChanges handelsbetingelser ved køb af brugt bil — pris, betaling, levering, garanti og fortrydelsesret.",
    path: "/handelsbetingelser",
  }),
  component: Handelsbetingelser,
});

function Handelsbetingelser() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: BREADCRUMB }} />
      <HeroBanner title="Handelsbetingelser" subtitle="Sådan handler vi — gennemskueligt og fair" />
      <section className="bg-background py-16">
        <div className="mx-auto max-w-3xl px-6 prose prose-neutral dark:prose-invert">
          <p>
            Disse betingelser gælder for køb af brugt bil hos {CONTACT.companyName} (CVR {CONTACT.cvr}),
            {" "}{CONTACT.addressLine}.
          </p>
          <h2>1. Priser og betaling</h2>
          <p>
            Alle priser er angivet i danske kroner inklusiv moms og afgifter, men ekskl. registrering og
            nummerplader. Betaling sker som hovedregel via bankoverførsel før udlevering. Kontant betaling
            modtages ikke for beløb over 19.999 kr (hvidvaskloven).
          </p>
          <h2>2. Reklamationsret</h2>
          <p>
            Som forbruger har du to års reklamationsret jf. købeloven. Reklamationsretten omfatter
            mangler, der var til stede ved overtagelsen af bilen, men ikke almindelig slitage eller
            fejl opstået efter overtagelse.
          </p>
          <h2>3. Fortrydelsesret</h2>
          <p>
            Da handlen indgås ved fysisk fremmøde, er der som udgangspunkt ikke fortrydelsesret efter
            forbrugeraftaleloven. Specifikke aftaler kan dog laves individuelt.
          </p>
          <h2>4. Garanti</h2>
          <p>
            Hvis der medfølger en garanti udover reklamationsretten, fremgår betingelserne af det
            udleverede garantibevis fra garantiudstederen.
          </p>
          <h2>5. Klagemuligheder</h2>
          <p>
            Klager kan indgives til Center for Klageløsning, Nævnenes Hus, Toldboden 2, 8800 Viborg
            ({" "}<a href="https://naevneneshus.dk" target="_blank" rel="noopener noreferrer">naevneneshus.dk</a>).
          </p>
          <h2>6. Lovvalg og værneting</h2>
          <p>
            Tvister afgøres efter dansk ret ved retten i Kolding.
          </p>
        </div>
      </section>
    </>
  );
}
